import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { colors } from "styles/colors";

MemoTextField.propTypes = {
    handleInputChange: PropTypes.func,
    text: PropTypes.string,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    editable: PropTypes.bool
}

// Компонент для отображения текстового поля с возможностью ввода текста
export function MemoTextField({handleInputChange, text, placeholder='', maxLength, editable, rows}) { 
    const [inputValue, setInputValue] = useState(text ? text : ''); 
    const handlChange = (event) => { 
        setInputValue(event.target.value); 
        handleInputChange(event.target.value); 
    }; 
    
    return ( 
        <TextField 
            value={inputValue} 
            onChange={handlChange} 
            multiline 
            placeholder={placeholder} 
            variant="filled" 
            rows={rows || 10} 
            inputProps={{ maxLength: maxLength || 1000 }} 
            InputProps={{ disableUnderline: true, readOnly: !editable }}  
            // disabled={!editable}
            
            sx={{ 
                width: '100%', 
                backgroundColor: 'white !important', 
                borderRadius: '10px',
                
                "& .MuiFilledInput-root": {backgroundColor: '#f8f9fa', borderRadius: '7px', border: 'none',},

                "& .MuiFilledInput-input": {color: 'black !important', fontWeight: 'normal !important', 
                    "&.Mui-disabled": {color: 'gray !important', WebkitTextFillColor: 'grey !important', opacity: 1, }},

                "& .MuiFilledInput-input::placeholder": {color: 'grey !important', opacity: 1}
            }}
        /> 
    ); 
}